<header class="admin-nav">
  <div class="admin-nav__inner">

    <!-- Brand -->
    <a [routerLink]="portalRoute" class="admin-nav__brand">
      @if (isSuperAdmin) {
        <div class="admin-nav__logo">
          <span class="admin-nav__logo-text">IL</span>
        </div>
        <div class="admin-nav__titles">
          <span class="admin-nav__title">Store Management</span>
          <span class="admin-nav__role">Super Admin</span>
        </div>
      } @else if (store) {
        <div class="admin-nav__store-logo">
          @if (store.logo) {
            <img [src]="store.logo" [alt]="store.name" class="admin-nav__store-logo-img" />
          } @else {
            <span class="admin-nav__store-logo-initials">{{ storeInitials }}</span>
          }
        </div>
        <div class="admin-nav__titles">
          <span class="admin-nav__title">{{ store.name }}</span>
          <span class="admin-nav__role">&#64;{{ store.username }}</span>
        </div>
      } @else {
        <div class="admin-nav__logo">
          <span class="admin-nav__logo-text">IL</span>
        </div>
        <div class="admin-nav__titles">
          <span class="admin-nav__title admin-nav__title--loading"></span>
          <span class="admin-nav__role admin-nav__role--loading"></span>
        </div>
      }
    </a>

    <!-- Desktop nav items -->
    <nav class="admin-nav__items" aria-label="Admin navigation">
      @if (isSuperAdmin) {
        <a routerLink="/super-admin/overview" routerLinkActive="admin-nav__item--active"
          class="admin-nav__item">
          <i class="fa-solid fa-chart-line" aria-hidden="true"></i>
          <span>Overview</span>
        </a>
        <a routerLink="/super-admin/stores" routerLinkActive="admin-nav__item--active"
          [routerLinkActiveOptions]="{ exact: false }" class="admin-nav__item">
          <i class="fa-solid fa-store" aria-hidden="true"></i>
          <span>Stores</span>
        </a>
        <a routerLink="/super-admin/products" routerLinkActive="admin-nav__item--active"
          class="admin-nav__item">
          <i class="fa-solid fa-box" aria-hidden="true"></i>
          <span>Products</span>
        </a>
        <a routerLink="/super-admin/users" routerLinkActive="admin-nav__item--active"
          class="admin-nav__item">
          <i class="fa-solid fa-users" aria-hidden="true"></i>
          <span>Users</span>
        </a>
        <a routerLink="/super-admin/analytics" routerLinkActive="admin-nav__item--active"
          class="admin-nav__item">
          <i class="fa-solid fa-chart-bar" aria-hidden="true"></i>
          <span>Analytics</span>
        </a>
      } @else {
        <a routerLink="/admin" routerLinkActive="admin-nav__item--active"
          [routerLinkActiveOptions]="{ exact: true }" class="admin-nav__item">
          <i class="fa-solid fa-gauge" aria-hidden="true"></i>
          <span>Dashboard</span>
        </a>
        <a [routerLink]="storeProductsRoute" class="admin-nav__item"
          [class.admin-nav__item--active]="isActive('/admin/stores')">
          <i class="fa-solid fa-box" aria-hidden="true"></i>
          <span>Products</span>
        </a>
      }
    </nav>

    <!-- Right: profile -->
    <div class="admin-nav__right">
      <div class="relative">
        <button type="button" (click)="toggleProfileMenu($event)" class="admin-nav__profile-btn"
          aria-label="Profile menu">
          <i class="fa-solid fa-user"></i>
        </button>

        @if (isProfileMenuOpen) {
          <div class="admin-nav__dropdown" (click)="onProfileMenuClick($event)">
            <div class="admin-nav__dropdown-header">
              <div class="admin-nav__avatar">
                <i class="fa-solid fa-user-shield"></i>
              </div>
              <div class="admin-nav__user-details">
                <span class="admin-nav__user-name">{{ currentUser?.name || 'Administrator' }}</span>
                <span class="admin-nav__user-email">{{ currentUser?.email }}</span>
              </div>
            </div>
            <div class="admin-nav__dropdown-divider"></div>
            <button type="button" (click)="onLogout()" class="admin-nav__dropdown-item admin-nav__dropdown-item--danger">
              <i class="fa-solid fa-right-from-bracket admin-nav__dropdown-icon"></i>
              <span>Logout</span>
            </button>
          </div>
        }
      </div>
    </div>

  </div>
</header>

<!-- Mobile bottom tab bar -->
<nav class="admin-mob-nav" aria-label="Mobile admin navigation">
  @if (isSuperAdmin) {
    <a routerLink="/super-admin/overview" routerLinkActive="admin-mob-nav__item--active"
      class="admin-mob-nav__item">
      <i class="fa-solid fa-chart-line" aria-hidden="true"></i>
      <span>Overview</span>
    </a>
    <a routerLink="/super-admin/stores" routerLinkActive="admin-mob-nav__item--active"
      [routerLinkActiveOptions]="{ exact: false }" class="admin-mob-nav__item">
      <i class="fa-solid fa-store" aria-hidden="true"></i>
      <span>Stores</span>
    </a>
    <a routerLink="/super-admin/products" routerLinkActive="admin-mob-nav__item--active"
      class="admin-mob-nav__item">
      <i class="fa-solid fa-box" aria-hidden="true"></i>
      <span>Products</span>
    </a>
    <a routerLink="/super-admin/users" routerLinkActive="admin-mob-nav__item--active"
      class="admin-mob-nav__item">
      <i class="fa-solid fa-users" aria-hidden="true"></i>
      <span>Users</span>
    </a>
    <a routerLink="/super-admin/analytics" routerLinkActive="admin-mob-nav__item--active"
      class="admin-mob-nav__item">
      <i class="fa-solid fa-chart-bar" aria-hidden="true"></i>
      <span>Analytics</span>
    </a>
  } @else {
    <a routerLink="/admin" routerLinkActive="admin-mob-nav__item--active"
      [routerLinkActiveOptions]="{ exact: true }" class="admin-mob-nav__item">
      <i class="fa-solid fa-gauge" aria-hidden="true"></i>
      <span>Dashboard</span>
    </a>
    <a [routerLink]="storeProductsRoute" class="admin-mob-nav__item"
      [class.admin-mob-nav__item--active]="isActive('/admin/stores')">
      <i class="fa-solid fa-box" aria-hidden="true"></i>
      <span>Products</span>
    </a>
    <a routerLink="/admin/edit" class="admin-mob-nav__item"
      [class.admin-mob-nav__item--active]="isActive('/admin/stores') && router.url.includes('/edit')">
      <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
      <span>Edit Store</span>
    </a>
  }
</nav>
